import React, { Component } from "react";
import { withRouter } from "react-router";
import { Form,Row,Modal } from "antd";
import { LinkTo, EllipsisDataValueWrapper, EllipsisContent } from "../../../../CommonComponents/commonStyles";
import { connect } from "react-redux";
import {
  UserContributionDetails,
  ProfileSectionHeading,
  ProfileInformationHeading,
  DetailsData,
  FirstColumn,
  SecondColumn,
  IconContainer,
  DetailsContainer,
  ItemWrapper,
  ProfileLink,
  CloseButton,
  EllipsisMfaEmailUnderline,
  DefaultIndicator,
  ModalButtonContainerchangePhNo
} from "../../styles";
import { DrawerContainer, CustomisedDrawer } from "../UpdateUserId/styles";
import Profile from "../../../../CommonComponents/svgs/Profile";
import Password from "../../../../assets/icons/password.svg";
import AccessKey from "../../../../assets/icons/access-key.svg";
import { 
  generateAccessKey,
  clearChangeUserId,
  clearErrMessage,
  clearChangemfaEmail,
  clearmfaEmailErrMessage,
  resendEmail,
  resendEmailClearFlag,
  changeMFAPhNo,
  changeMFAPhNoClearFlag,
  refreshMFAPhNoCom
} from "../../actions";
import { getAccountData, getPrimaryAccount, isGeminiUser } from "../../../../utils/sessionUtil";
import { BUSINESS_FUNCTION } from "../../../../CSR/utils/csrBusinessFunctionMapper";
import { checkCSRBusinessFunction } from "../../../../CSR/utils/CommonUtils";
import { recordError } from "../../../../utils/commonUtil";
import { ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import PropTypes from 'prop-types';
import { selectGetAccessKey,selectValidTill, } from "../../selectors";
import { selectCsrBusinessFunction } from "../../../../selectors/globalSelectors";
import GlobalModal from "../../../../CommonComponents/AlertModal/GlobalModal";
import UpdateUserIDComponent from "../UpdateUserId/UpdateUserIDComponent";
import UpdateEmailIDComponent from "../UpdateEmailId/UpdateEmailIDComponent";
import close from "../../../../assets/svg/cancel.svg";
import { logOut } from '../../../../Auth0/SessionProvider';
import EditLinkToPill from "../../../../CommonComponents/EditLinkToPill/EditLinkToPill";
import Email from "../../../../assets/icons/email.svg";
import Phone from "../../../../assets/icons/phone.svg";
import { CapsuleButton,GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";
import AlertBox from '../../../../CommonComponents/AlertBox';
class WebAccess extends Component {
  constructor(props){
    super(props);
    this.webAccessTitle = 'Web Access Information';
    this.generateBtnLbl = 'Generate Access Key';
    this.state = {
      validKey: false,
      interval: '',
      visible: false,
      modalVisible: false,
      emailvisible: false,
      emailmodalVisible: false,
      maskClose:true,
      resendEmailSucMsg: '',
      isClickedVerEmail: false,
      isClickedResendEmail: false,
      changePhNomodalVisible: false
    }   
    this.emailTechError = {
      heading: "Alert",
      line1: "<p>Technical error occurred. Please try again</p>",
      continue: "OKAY"     
    }; 
  }

  handleWebAccessAction(event, label) {
    this.props.analyticsTracking(event, this.getWebAccessTitle(), label);
  }

  setWebAccessTitle = (title = '') => {
    if(title) {
      this.webAccessTitle = title;
    }
  }

  getWebAccessTitle = () => {
    return this.webAccessTitle;
  }

  showAccessKey= () => {
    try {
      this.props.generateAccessKey({
        metaData: {
          method: "GET",        
          url: `/donor-portal/api/profile/${getPrimaryAccount().userId}/generateAccessKeyWithAccountIdAndPartyId?partyId=${getAccountData().partyId}`,
        }
      });
      this.handleWebAccessAction('select', this.generateBtnLbl);
    } catch (error) {
      recordError(error);
    }
  } 

  copyToClipBoard(accessKey) {
    if(accessKey) {
      const handler =  (e) => {
        e.clipboardData.setData('text/plain', accessKey);
        e.preventDefault();
      } ;
      // Don't use anonymous functions for callback methods
      document.addEventListener('copy',handler , true);
      document.execCommand('copy');
      GlobalModal({ contents: 'Copied text: ' + accessKey + ' to clipboard'});
      // alert('Copied text: ' + accessKey + " to clipboard");

      // this line will remove the copy listner from DOM, 
      document.removeEventListener('copy',handler,true);
    }
  }
  
  componentDidMount() {
    const { profileData, accessKeyExpiry } = this.props;  

    this.state.interval = setInterval(() => {
      if(!profileData.webAccess.accessKeyLinked) {
        let date = new Date();
        let currTime = date.getTime();        
        if(accessKeyExpiry && currTime > accessKeyExpiry && this.state.validKey) {
          this.setState({
            validKey: false
          });          
        } else if(!accessKeyExpiry && profileData.webAccess.accessKeyValidTill && currTime > profileData.webAccess.accessKeyValidTill && this.state.validKey){       
          this.setState({
            validKey: false
          }); 
        }

      }

    }, 3000);

    this.props.resendEmailClearFlag()
  }

  componentWillUnmount() {
    if(this.state.interval)
      clearInterval(this.state.interval);
  }

  showDrawer = () => {
    this.setState({
        visible: true
    });        
    this.handleWebAccessAction('update', 'Update User ID');
  };

  showDrawerEmail = () => {
    this.setState({
      emailvisible: true
    });        
    this.handleWebAccessAction('update', 'Update Email');
  };
  
  onCloseEmail(page) {
    if (this.props.mfaEmailExistsBefore) {
        this.props.clearmfaEmailErrMessage();
    }
    this.props.clearChangemfaEmail('');
   let emailmodalVisible = this.props.updatemfaEmailData?true:false;
   if(emailmodalVisible){
   this.logout("updatemfaEmail");
  }else{
    this.setState({
      emailvisible: false,                     
      });
  }
};

onClose(page) {
  if (this.props.useridExistsBefore) {
      this.props.clearErrMessage();
  }
  this.props.clearChangeUserId('');
  this.props.form.setFields( { userName: { errors: null } });
 this.props.form.resetFields(['userName'])
 let modalVisible = this.props.updateUserIdData?true:false;
 if(modalVisible){
 this.logout("updateUserId");
}else{
  this.setState({
        visible: false,                     
    });
}
};

handleSubmit = e => {        
  e.preventDefault();
  this.props.form.validateFieldsAndScroll((err, values) => {
  
      if (!err) {
          setTimeout(() => this.props.form.resetFields(['userName']), 0);
      }
  });
};

  closeModal = () => {
    this.setState({
        modalVisible: false
    })        
    this.logout();
}

closeModalTechErr = () => {
  this.props.resendEmailClearFlag()  
}

closeModalTechErrchangeMFAPhNo = () => {
  this.props.changeMFAPhNoClearFlag()  
}

logout = (fromPage='') => {
sessionStorage.setItem('userIdUpdated', true);
if(!isGeminiUser()){
logOut(fromPage);
}   
};

maskClose = (value) =>{
  this.setState({
      maskClose: !value
  })
}

handleResendEmail = (value,email) => {
  try {
    if(value === 1){
    this.setState({ isClickedVerEmail: true }); 
    }else if(value === 2){
      this.setState({ isClickedResendEmail: true });
      setTimeout(()=>{
        this.setState({ isClickedResendEmail: false });
      },3000)
    } 
    this.props.resendEmail({
      metaData: {
        method: "POST",
        url: `/donor-portal/api/profile/${
          getPrimaryAccount().userId
          }/sendMfaVerificationMail?partyId=${getAccountData().partyId}`,
        page: "myProfile",
        data: {"mfaEmailId":email }
      }
    });
  } catch (error) {
    recordError(error);
  }
};

// Change phone number Modal starts
showModal = () => {
  this.setState({
    changePhNomodalVisible: true
  });
};  

handleOk = (e) => {
  try {
  this.setState({
    changePhNomodalVisible: false
  }); 
  this.props.changeMFAPhNo({
    metaData: {
      method: "POST",
      url: `/donor-portal/api/profile/${
        getPrimaryAccount().userId
        }/deleteMFAPhoneNo?partyId=${getAccountData().partyId}`,
        page: "myProfile"
    }
  });
  } catch (error) {
  recordError(error);
}  
};

handleCancel = e => {
  this.setState({
    changePhNomodalVisible: false
  });
};
// Change phone number Modal ends

componentDidUpdate(prevProps){
  if(this.props.changeMFAPhNoData && prevProps.changeMFAPhNoData !== this.props.changeMFAPhNoData ) {
    if(isGeminiUser()){
      this.props.refreshMFAPhNoCom();
      }
    this.logout("changeMFAPhoneNo");
  }
}

showTechnicalPopup = () => {
  if(this.props.updateresendEmailFailed || 
    this.props.changeMFAPhNoFailed) {
      return true;
    } else {
      return false;
    }
}

primaryBtnAction = () => {
  if(this.props.updateresendEmailFailed) {
    this.closeModalTechErr();
  } else if(this.props.changeMFAPhNoFailed) {
    this.closeModalTechErrchangeMFAPhNo();
  }
}

render() {   
    //Added by Nixon - For CSR User check
    let userData = JSON.parse(sessionStorage.getItem('userData'));
    const isAdminUser = userData?userData.csrUser:null;
    // --/Nixon
    const { accessKeyData, profileData, accessKeyExpiry, csrBusinessFunction  } = this.props;
    let accessKey = '';

    let date = new Date();

    let currTime = date.getTime();

  const FormItem = Form.Item;
    if(profileData.webAccess.accessKeyExpired === true){
      this.state.validKey = false; 
    } else if(!accessKeyExpiry && profileData.webAccess.accessKeyValidTill && profileData.webAccess.accessKeyValidTill > currTime) {
      this.state.validKey = true;
      accessKey = profileData.webAccess.accessKey;
    }
    
    if(accessKeyExpiry && accessKeyExpiry > currTime) {
      accessKey = accessKeyData;
      this.state.validKey = true;
    }
    if (this.props.updateresendEmailData || this.props.updateresendEmailFailed) {
      this.state.isClickedVerEmail = false;  
     }

    return (
      <div>
          <AlertBox
            show={this.showTechnicalPopup()}
            closable={false}
            field_page="My Profile"
            name="Technical Error"
            className="resendEmail-Alert"
            primaryBtnEvent={this.primaryBtnAction.bind(this)}
            defaultContent={this.emailTechError}
          />
          
          <Modal
                title="Change your phone number"
                visible={this.state.changePhNomodalVisible}               
                onCancel={this.handleCancel}
                centered={true}
                closable={false}
                className="changePhoneNo-Alert"
                footer={[
                  <ModalButtonContainerchangePhNo>
                    <GeneralButton
                      text="Cancel"
                      type="functional"
                      width="9.375rem"
                      disabled={false}
                      id={`btnCancel`}
                      onClick={this.handleCancel}
                      inverted={true}
                    />
                    <GeneralButton
                      text="Confirm"
                      type="functional"
                      width="9.375rem"
                      disabled={false}
                      id={`btnContinue`}
                      onClick={this.handleOk}
                      inverted={false}
                    />
                  </ModalButtonContainerchangePhNo>
                ]}
              >
               { isGeminiUser() ? (<p>
                To change your phone number you must click Confirm. Once you log back in, you will be prompted to change your phone number.
               </p>) : (<p>
                To change your phone number you must click Confirm and you’ll be logged out of your account. Once you log back in, you will be prompted to change your phone number.
               </p>) }
              </Modal>
        <ProfileSectionHeading>          
          <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_2_title" defaultMessage="Web Access Information" setTitle={this.setWebAccessTitle} />
        </ProfileSectionHeading>
        <Row>
          <FirstColumn lg={9} sm={24} xs={24}>
          <DetailsContainer>
              <IconContainer>
                <Profile />
              </IconContainer>
              <DetailsData>
                <div className={isGeminiUser() ? 'not-allowed-cursor' : ''}  id="anrUpdateUserId" >
                <ProfileInformationHeading className="myProfileFontFix">User ID</ProfileInformationHeading>
                  <EditLinkToPill                       
                  data-test="linkToPill-block"
                  advisorType="primary"
                  active="Primary"
                  isDisabled={isGeminiUser() ? true : false}
                  onClick={ this.showDrawer.bind(this) }
                />
                  </div>
                <CustomisedDrawer
                    placement={this.state.placement}
                    closable={true}
                    onClose={this.onClose.bind(this)}
                    visible={this.state.visible}
                    maskClosable={this.state.maskClose}
                    >
                    {this.state.visible && <CloseButton src={close}/>}
                    {       <DrawerContainer>
                                <UpdateUserIDComponent
                                    onClose={this.onClose.bind(this)}
                                    userId={this.props.profileData.webAccess.userName}
                                    id={this.props.profileData.webAccess.id}
                                    changeMaskClose = {this.maskClose}
                                />
                            </DrawerContainer>
                        }
                </CustomisedDrawer>
                
                <UserContributionDetails>
                  <ItemWrapper>
                    {this.props.profileData.webAccess.userName}
                  </ItemWrapper>
                </UserContributionDetails>
              </DetailsData>
            </DetailsContainer>

            { this.props.profileData.webAccess.mfaEmailId && <DetailsContainer className="wrapper-myprofileEmail">
              <IconContainer>
              <img src={Email} alt="email"/>
              </IconContainer>
              <DetailsData className="myProfilemfaEmailSection">
                <div className={isGeminiUser() ? 'not-allowed-cursor' : ''}  id="anrUpdateEmailId" >
                <ProfileInformationHeading className="myProfileFontFix">Email</ProfileInformationHeading>
                  <EditLinkToPill                       
                  data-test="linkToPill-block"
                  advisorType="primary"
                  active="Primary"
                  isDisabled={isGeminiUser() ? true : false}
                  onClick={ this.showDrawerEmail.bind(this) }
                />
                  </div>
                <CustomisedDrawer
                    placement={this.state.placement}
                    closable={true}
                    onClose={this.onCloseEmail.bind(this)}
                    visible={this.state.emailvisible}
                    maskClosable={this.state.maskClose}
                    >
                    {this.state.emailvisible && <CloseButton src={close}/>}
                    {       <DrawerContainer>
                                <UpdateEmailIDComponent
                                    onClose={this.onCloseEmail.bind(this)}
                                    emailId={this.props.profileData.webAccess.mfaEmailId}
                                    id={this.props.profileData.webAccess.id}
                                    changeMaskClose = {this.maskClose}
                                />
                            </DrawerContainer>
                        }
                </CustomisedDrawer>
                
                <UserContributionDetails>
                  <ItemWrapper>
                  <EllipsisDataValueWrapper>
                              <EllipsisMfaEmailUnderline ><ItemWrapper >{this.props.profileData.webAccess.mfaEmailId}</ItemWrapper></EllipsisMfaEmailUnderline>
                              <EllipsisContent id="anrmfaEmail">                               
                              {this.props.profileData.webAccess.mfaEmailId}
                              </EllipsisContent>
                            </EllipsisDataValueWrapper>
                  </ItemWrapper>
                      { this.props.profileData.webAccess.isMfaEmailVerified !== null && this.props.profileData.webAccess.isMfaEmailVerified === false ? 
                      this.props.profileData.webAccess.isMfaVerificationEmailSent != null && this.props.profileData.webAccess.isMfaVerificationEmailSent === true ? <CapsuleButton disabled = { this.state.isClickedResendEmail ? true : false } text="RESEND VERIFICATION EMAIL" onClick={() => this.handleResendEmail(2,this.props.profileData.webAccess.mfaEmailId)} styles="btn_resendmail"/>
                      : !this.props.updateresendEmailData ? 
                      <CapsuleButton disabled = { this.state.isClickedVerEmail ? true : false }  text="VERIFY YOUR EMAIL" onClick={() => this.handleResendEmail(1,this.props.profileData.webAccess.mfaEmailId)} styles="btn_resendmail"/> 
                      : <CapsuleButton disabled = { this.state.isClickedResendEmail ? true : false } text="RESEND VERIFICATION EMAIL" onClick={() => this.handleResendEmail(2,this.props.profileData.webAccess.mfaEmailId)} styles="btn_resendmail"/> 
                      : null }
                      { this.props.profileData.webAccess.isMfaEmailVerified != null && this.props.profileData.webAccess.isMfaEmailVerified === false ? 
                      this.props.profileData.webAccess.isMfaVerificationEmailSent != null && this.props.profileData.webAccess.isMfaVerificationEmailSent === true ? (<span className="resendEmailSuccess">Verification email sent</span>) : 
                      this.props.updateresendEmailData ? (<span className="resendEmailSuccess">Verification email sent</span>) : null : null } 
                </UserContributionDetails> 
              </DetailsData>
              { this.props.profileData.webAccess.isMfaEmailVerified && <DefaultIndicator className="veremail-mt-30">VERIFIED EMAIL</DefaultIndicator> }
            </DetailsContainer>     
  }
             <DetailsContainer>
              <IconContainer>
                <img src={Password} alt="password ico"/>
              </IconContainer>
              <DetailsData>
                <ProfileInformationHeading className="myProfileFontFix">Password</ProfileInformationHeading>
                <UserContributionDetails><ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_reset_password_description" defaultMessage="<p>To reset your password, log out of your online account. Then log back in and select Forgot Password?</p>" /></UserContributionDetails>
              </DetailsData>
            </DetailsContainer> 

        
          </FirstColumn>
          <SecondColumn lg={15} sm={24} xs={24}>
          { this.props.profileData.webAccess.mfaPhoneNo  && <DetailsContainer>
              <IconContainer>
              <img src={Phone} alt="phone" />
              </IconContainer>
              <DetailsData>
                <div id="anrmfaPhonenumber" >
                <ProfileInformationHeading className="myProfileFontFix">Phone number</ProfileInformationHeading>
                  </div>
                <UserContributionDetails>
                  <ItemWrapper>
                    { this.props.profileData.webAccess.mfaPhoneNo }
                  </ItemWrapper>
                </UserContributionDetails>
                <LinkTo id="anrChangePhonenumber" onClick={this.showModal} >
                      <ProfileLink>
                      Change Phone number
                      </ProfileLink>
                </LinkTo>
              </DetailsData>
            </DetailsContainer> }

            <DetailsContainer>
              <IconContainer>
                <img src={AccessKey} alt="accesskey ico" />
              </IconContainer>
              {
                this.state.validKey && profileData.webAccess.accessKeyLinked !== true
                && <DetailsData>
                    <ProfileInformationHeading className="myProfileFontFix">
                      Access Key
                    </ProfileInformationHeading>
                    <UserContributionDetails>                      
                      <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_access_key_generated" defaultMessage="<p>The Access Key will expire four hours from the time that it is generated.</p>" />
                    </UserContributionDetails>
                    <LinkTo onClick={ this.copyToClipBoard.bind(this, accessKey) }>
                      { accessKey }
                    </LinkTo>
                  </DetailsData>
              }
              {
                !this.state.validKey && profileData.webAccess.accessKeyLinked !== true
                && <DetailsData>
                    <ProfileInformationHeading className="myProfileFontFix">
                      Access Key
                    </ProfileInformationHeading>
                    <UserContributionDetails>                      
                      <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_access_key_not_generated" defaultMessage="<p>Click button below to generate your access key to link your Vanguard accounts.Once linked, you can initiate a contribution to Vanguard Charitable from vanguard.com.</p>" />
                    </UserContributionDetails>
                    <LinkTo id="anrGenerate" onClick={this.showAccessKey} className={ isGeminiUser() && checkCSRBusinessFunction(BUSINESS_FUNCTION['DONOR_PORTAL_ACCESS_KEY_FULL_ACCESS'], csrBusinessFunction) ? 'disable-hyperlink' : ''}>
                      <ProfileLink>
                        Generate
                      </ProfileLink>
                    </LinkTo>
                  </DetailsData>
              } 

              {
                profileData.webAccess.accessKeyLinked === true
                && <DetailsData>
                    <ProfileInformationHeading className="myProfileFontFix">
                      Access Key
                    </ProfileInformationHeading>
                    <UserContributionDetails>                      
                      <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_access_key_linked" defaultMessage="<p>You have successfully linked your account.</p>" />
                    </UserContributionDetails>                    
                  </DetailsData>                
              }
              
            </DetailsContainer>

          </SecondColumn>
        </Row>
      </div>
    );
  }
}

WebAccess.propTypes = {
  analyticsTracking: PropTypes.func.isRequired,
  profileData: PropTypes.object,
  userId: PropTypes.string.isRequired  
}
const WrappedRegistrationForm = Form.create({ name: "register" })(
  WebAccess
);

export const mapStateToProps = state => {
  return {
  accessKeyData:selectGetAccessKey(state.toJS()),
  accessKeyExpiry: selectValidTill(state.toJS()),
  csrBusinessFunction: selectCsrBusinessFunction(state.toJS()),
  incorrectResponseCount: state.getIn(["myAccount", "incorrectUseridResponseCount"]),
  updateUserIdData: state.getIn(["myAccount", "updateUserIdData"]),
  correctResponseCount: state.getIn(["myAccount", "correctUseridResponseCount"]),
  useridExistsBefore: state.getIn(["myAccount","useridExistsBefore"]),
  mfaEmailExistsBefore: state.getIn(["myAccount","mfaEmailExistsBefore"]),
  incorrectmfaEmailResponseCount: state.getIn(["myAccount", "incorrectmfaEmailResponseCount"]),
  updatemfaEmailData: state.getIn(["myAccount", "updatemfaEmailData"]),
  updateresendEmailData: state.getIn(["myAccount", "updateresendEmailData"]),
  updateresendEmailFailed: state.getIn(["myAccount", "updateresendEmailFailed"]),
  changeMFAPhNoData: state.getIn(["myAccount", "changeMFAPhNoData"]),
  changeMFAPhNoFailed: state.getIn(["myAccount", "changeMFAPhNoFailed"]),
  correctmfaEmailResponseCount: state.getIn(["myAccount", "correctmfaEmailResponseCount"])
}};

export const mapDispatchToProps = dispatch => ({
  generateAccessKey: (data) => dispatch(generateAccessKey(data)),
  clearChangeUserId: data => dispatch(clearChangeUserId(data)),
  clearErrMessage: () => dispatch(clearErrMessage()),
  clearChangemfaEmail: data => dispatch(clearChangemfaEmail(data)),
  clearmfaEmailErrMessage: () => dispatch(clearmfaEmailErrMessage()),
  resendEmail: data => dispatch(resendEmail(data)),
  resendEmailClearFlag: () => dispatch(resendEmailClearFlag()),
  changeMFAPhNo: data => dispatch(changeMFAPhNo(data)),
  changeMFAPhNoClearFlag: () => dispatch(changeMFAPhNoClearFlag()),
  refreshMFAPhNoCom: () => dispatch(refreshMFAPhNoCom())
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WrappedRegistrationForm)
);